<script lang="ts">
    import {onMount} from 'svelte'
    import {
        aboutYouDetails,
        accessories,
        chosenDateOptions,
        chosenSlotOption,
        operatorId,
    } from "../stores";
    import {mandatory} from "@docsndata/lang-util";
    import {v4 as uuid} from 'uuid'
    import {spinning} from "../spinning";
    import {push} from 'svelte-spa-router'
    import {invitation} from "../state/appState";
    import {bookingByInvitePayload} from "./bookingByInvitePayload";

    onMount(async () => {
        $spinning = true
        try {
            const bookingId = uuid()
            const payload = bookingByInvitePayload($aboutYouDetails, mandatory($chosenDateOptions, "No selected product"), $chosenSlotOption, $accessories, bookingId, mandatory($invitation, "No invitation"), $operatorId)
            const url = "https://europe-west2-docs-n-data.cloudfunctions.net/customEndpoint/v1/thesmartwashltd.com/bookingByInvitation"
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify(payload)
            })
            if (!response.ok) {
                alert(`code = ${response.status}, text = ${response.statusText}`)
            } else {
                push("/thanks")
            }
        } finally {
            $spinning = false
        }
    })
</script>